import script from "./SectionThreePanels.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionThreePanels.vue?vue&type=script&setup=true&lang=js"

import "./SectionThreePanels.vue?vue&type=style&index=0&id=3925c1dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3925c1dc"]])

export default __exports__